import { render } from "./PDSPage.vue?vue&type=template&id=3b7a3d27&scoped=true"
import script from "./PDSPage.vue?vue&type=script&lang=js"
export * from "./PDSPage.vue?vue&type=script&lang=js"

import "./PDSPage.vue?vue&type=style&index=0&id=3b7a3d27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7a3d27"]])

export default __exports__